import Autocomplete from '@mui/material/Autocomplete'
import Stack from '@mui/material/Stack'
import { useFormContext } from 'react-hook-form'

import { User } from '@/Components/Pages/Accounts/types'

import EmailField from '@/Components/Common/Inputs/EmailField'
import TextField from '@/Components/Common/Inputs/TextField'

type DetailFormFieldsProps = {
  timeZoneOptions: [string, string][]
}

const DetailFormFields: React.FC<DetailFormFieldsProps> = ({
  timeZoneOptions
}) => {
  const {
    register,
    watch,
    setValue,
    formState: { errors }
  } = useFormContext<User>()

  const timeZone = watch('timeZone')

  return (
    <>
      <Stack gap={2}>
        <TextField
          {...register('firstName', {
            required: 'First name is required'
          })}
          label="First Name"
          fullWidth
          required
          error={!!errors.firstName}
          helperText={errors.firstName?.message as string}
        />
        <TextField
          {...register('lastName', {
            required: 'Last name is required'
          })}
          label="Last Name"
          fullWidth
          required
          error={!!errors.lastName}
          helperText={errors.lastName?.message as string}
        />
        <EmailField register={register} errors={errors} fullWidth />
        <TextField {...register('title')} label="Title" fullWidth />
        <TextField
          {...register('organization')}
          label="Organization"
          fullWidth
        />
        <Autocomplete
          options={timeZoneOptions}
          getOptionLabel={([label]) => label}
          value={timeZoneOptions.find(([, v]) => v === timeZone)}
          onChange={(_, newValue) => {
            if (newValue) {
              setValue('timeZone', newValue[1], { shouldValidate: true })
            } else {
              setValue('timeZone', '', { shouldValidate: true })
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Timezone"
              {...register('timeZone', { required: true })}
              fullWidth
              required
            />
          )}
          isOptionEqualToValue={(option, value) => option[0] === value[0]}
          fullWidth
        />
      </Stack>
    </>
  )
}

export default DetailFormFields
